import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Form } from 'react-bootstrap';
import Swal from 'sweetalert2';

const VIPSettings = () => {
    const navigate = useNavigate();
    const [vipData, setVipData] = useState({
        vip_font: '',
        vip_color: '',
        vip_frame: '',
    });
    const [isVIP, setIsVIP] = useState(false);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchVIPData = async () => {
            try {
                const res = await fetch('https://api.fantasyworldtrpg.cz/echo/get_vip_settings.php', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        user: localStorage.getItem('echo_user')
                    })
                });
                const data = await res.json();
                if (data.success && data.settings) {
                    setIsVIP(true);
                    setVipData({
                        vip_font: data.settings.font || '',
                        vip_color: data.settings.color || '',
                        vip_frame: data.settings.frame || '',
                    });
                } else {
                    console.error(data.message);
                    navigate('/');
                }
            } catch (error) {
                console.error('Chyba při načítání VIP dat:', error);
                navigate('/');
            } finally {
                setLoading(false);
            }
        };
        fetchVIPData();
    }, [navigate]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setVipData(prev => ({ ...prev, [name]: value }));
    };

    const handleSave = async () => {
        try {
            const res = await fetch('https://api.fantasyworldtrpg.cz/echo/update_vip.php', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    user: localStorage.getItem('echo_user'),
                    ...vipData
                })
            });
            const data = await res.json();
            if (data.success) {
                // Použití SweetAlert2 pro potvrzení
                Swal.fire({
                    title: 'Hotovo!',
                    text: 'VIP nastavení bylo úspěšně uloženo!',
                    icon: 'success',
                    confirmButtonText: 'OK'
                }).then(() => {
                    navigate('/profile/' + localStorage.getItem('echo_user'));
                });
            } else {
                Swal.fire({
                    title: 'Chyba!',
                    text: 'Došlo k problému při ukládání VIP nastavení.',
                    icon: 'error',
                    confirmButtonText: 'Zkusit znovu'
                });
            }
        } catch (error) {
            console.error('Chyba při ukládání VIP nastavení:', error);
            Swal.fire({
                title: 'Chyba!',
                text: 'Nepodařilo se uložit VIP nastavení.',
                icon: 'error',
                confirmButtonText: 'Zkusit znovu'
            });
        }
    };

    if (loading) return <div className="text-center my-5">Načítání...</div>;
    if (!isVIP) return null;

    return (
        <div className="container mt-5 py-5">
            <h2 className="text-center text-danger mb-4">VIP Nastavení</h2>
            <Form>
                <Form.Group className="mb-3">
                    <Form.Label>Font jména</Form.Label>
                    <Form.Select
                        name="vip_font"
                        value={vipData.vip_font}
                        onChange={handleChange}
                    >
                        <option value="">Žádný</option>
                        <option value="Arial">Arial</option>
                        <option value="Verdana">Verdana</option>
                        <option value="Tahoma">Tahoma</option>
                        <option value="Trebuchet MS">Trebuchet MS</option>
                        <option value="Georgia">Georgia</option>
                        <option value="Times New Roman">Times New Roman</option>
                        <option value="Courier New">Courier New</option>
                        <option value="Lucida Console">Lucida Console</option>
                        <option value="Impact">Impact</option>
                        <option value="Palatino Linotype">Palatino Linotype</option>
                        <option value="Book Antiqua">Book Antiqua</option>
                        <option value="Comic Sans MS">Comic Sans MS</option>
                    </Form.Select>

                    <div style={{ fontFamily: vipData.vip_font, marginTop: '10px' }}>
                        <h3 style={{ color: vipData.vip_color }}>Náhled textu</h3>
                    </div>
                </Form.Group>

                <Form.Group className="mb-3">
                    <Form.Label>Barva jména</Form.Label>
                    <Form.Control
                        type="color"
                        name="vip_color"
                        value={vipData.vip_color}
                        onChange={handleChange}
                    />
                </Form.Group>

                <Form.Group className="mb-3">
                    <Form.Label>Rámeček profilovky</Form.Label>
                    <Form.Select
                        name="vip_frame"
                        value={vipData.vip_frame}
                        onChange={handleChange}
                    >
                        <option value="">Žádný</option>
                        <option value="gold">Zlatý</option>
                        <option value="rainbow">Duha</option>
                        <option value="glow">Bílá záře</option>
                        <option value="blueglow">Modrá záře</option>
                        <option value="pinkglow">Růžová záře</option>
                        <option value="purpleglow">Fialová záře</option>
                        <option value="greenglow">Zelená záře</option>
                        <option value="orangeglow">Oranžová záře</option>
                    </Form.Select>
                </Form.Group>

                <Button variant="danger" onClick={handleSave}>
                    Uložit nastavení
                </Button>
            </Form>
        </div>
    );
};

export default VIPSettings;
